module.exports = __webpack_public_path__ + "static/media/img-restaurant-ph.f027243a.svg";